import { mdiCrosshairsGps, mdiMagnify, mdiMinus, mdiPipeValve, mdiPlus } from '@mdi/js'

export const MAP_PICKER_ICON_OPERATORS = mdiPipeValve
import { NavMdiIcon } from '../../NavTabIcons'

type MapCustomControlsProps = {
  onZoomIn: () => void
  onZoomOut: () => void
  onSearch: () => void
  onCenter: () => void
  onOpenPicker?: () => void
  pickerAriaLabel?: string
  pickerIconPath?: string
}

function MapControlButton({
  label,
  iconPath,
  onClick,
}: {
  label: string
  iconPath: string
  onClick: () => void
}) {
  return (
    <button type="button" className="map-control-btn" onClick={onClick} aria-label={label} title={label}>
      <NavMdiIcon path={iconPath} size={1.35} className="map-control-btn-icon" />
    </button>
  )
}

/** Mobile `Map.js` `ButtonColumn` parity — replaces stock Mapbox NavigationControl. */
export function MapCustomControls({
  onZoomIn,
  onZoomOut,
  onSearch,
  onCenter,
  onOpenPicker,
  pickerAriaLabel = 'Operators',
  pickerIconPath = MAP_PICKER_ICON_OPERATORS,
}: MapCustomControlsProps) {
  return (
    <div className="map-custom-controls" aria-label="Map controls">
      <MapControlButton label="Zoom in" iconPath={mdiPlus} onClick={onZoomIn} />
      <MapControlButton label="Zoom out" iconPath={mdiMinus} onClick={onZoomOut} />
      <MapControlButton label="Search address" iconPath={mdiMagnify} onClick={onSearch} />
      <MapControlButton label="Center map" iconPath={mdiCrosshairsGps} onClick={onCenter} />
      {onOpenPicker ? (
        <MapControlButton label={pickerAriaLabel} iconPath={pickerIconPath} onClick={onOpenPicker} />
      ) : null}
    </div>
  )
}
